import { render, staticRenderFns } from "./FarmersReport.vue?vue&type=template&id=137e8fc7&scoped=true"
import script from "./FarmersReport.vue?vue&type=script&lang=js"
export * from "./FarmersReport.vue?vue&type=script&lang=js"
import style0 from "./FarmersReport.vue?vue&type=style&index=0&id=137e8fc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137e8fc7",
  null
  
)

export default component.exports